import { all, call, put, takeEvery } from 'redux-saga/effects'
import { API } from '@Root/API'
import { snackbarActions } from '@Store/snackbar'
import { errorMessage } from '@Root/helpers'
import { actions } from './academic.actions'
import * as types from './academic.types'
import { contactActions } from '@Root/store'

function* get({ payload }) {
	yield put(actions.toggleLoading(true))
	const { contactId } = payload
	try {
		const { data } = yield call(API.contact.person.academic.get, contactId)
		yield put(actions.set(data.data))
		yield put(actions.setPermissions(data.permissions))
	} catch (error) {
		yield put(snackbarActions.setSnackbar({ text: errorMessage(error), isError: true }))
	}
	yield put(actions.toggleLoading(false))
}

function* edit({ payload }) {
	yield put(actions.toggleLoading(true))
	try {
		const { data } = yield call(API.contact.person.academic.edit, payload)
		yield put(actions.set(data.data))
		yield put(actions.toggleSuccess(true))
		yield put(snackbarActions.setSuccessNotification({ text: 'The academic information has been saved successfully!' }))
	} catch (error) {
		yield put(snackbarActions.setSnackbar({ text: errorMessage(error), isError: true }))
	}
	yield put(actions.toggleSuccess(false))
	yield put(actions.toggleLoading(false))
}

function* remove({ payload }) {
	yield put(actions.toggleLoading(true))
	const { contactId, relationshipId } = payload
	try {
		const { data } = yield call(API.contact.person.academic.remove, contactId, relationshipId)
		yield put(actions.set(data))
		yield put(contactActions.get({ contactId }))
		yield put(snackbarActions.setSuccessNotification({ text: 'The academic information has been deleted successfully!' }))
	} catch (error) {
		yield put(snackbarActions.setSnackbar({ text: errorMessage(error), isError: true }))
	}
	yield put(actions.toggleLoading(false))
}

function* getStaticOptions() {
	try {
		const response = yield call(API.contact.person.academic.options.getStatic)
		const formattedData = {
			institutions: response[0].data.data.map(obj => ({ value: obj.id, label: obj.name })),
		}
		yield put(actions.setOptions({ name: 'static', data: formattedData }))
	} catch (error) {
		yield put(snackbarActions.setSnackbar({ text: errorMessage(error), isError: true }))
	}
}

export function* rootSaga() {
	yield all([
		takeEvery(types.GET_ACADEMIC, get),
		takeEvery(types.EDIT_ACADEMIC, edit),
		takeEvery(types.DELETE_ACADEMIC, remove),
		takeEvery(types.GET_STATIC_OPTIONS, getStaticOptions),
	])
}
